var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemservLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 130.23",
    style: {
      enableBackground: "new 0 0 595.28 130.23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n\t.st1{fill:#fff;}\n\t.st2{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M567.77,53.87l-32.46,68.14h-24.64l-28.04-68.14h24.52l16.34,41.62l20.61-41.62L567.77,53.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M547.14,47.75l8.82-17.81l23.21,0l-8.48,17.81L547.14,47.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M559,23.8l8.82-17.81h22.76L582.1,23.8L559,23.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.56,122.08l-20.12-28.3c-2.26,0.25-4.53,0.38-7.04,0.38H18.75v27.92H9.44V34.05h32.95 c22.39,0,35.97,11.32,35.97,30.18c0,13.83-7.29,23.52-20.12,27.67l21.51,30.18H69.56z M69.05,64.23c0-14.09-9.31-22.13-26.91-22.13 H18.75v44.14h23.39C59.75,86.24,69.05,78.07,69.05,64.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.61,91.77H93.28c1.01,13.83,11.57,23.01,26.03,23.01c8.05,0,15.22-2.89,20.25-8.68l5.03,5.79 c-5.91,7.04-15.09,10.82-25.53,10.82c-20.63,0-34.71-14.09-34.71-33.71s13.71-33.58,32.32-33.58c18.61,0,32.07,13.71,32.07,33.58 C148.74,89.76,148.61,90.77,148.61,91.77z M93.28,85.11h46.91c-1.13-12.95-10.56-22.01-23.52-22.01 C103.84,63.1,94.41,72.15,93.28,85.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.66,83.72v38.36h-8.93V84.6c0-13.96-7.04-21.13-18.99-21.13c-13.58,0-22.13,8.8-22.13,23.9v34.71h-8.93 V84.6c0-13.96-7.04-21.13-19.12-21.13c-13.46,0-22.13,8.8-22.13,23.9v34.71h-8.93V55.93h8.55V68c4.65-7.92,13.21-12.58,24.27-12.58 c10.94,0,19.49,4.65,23.52,13.96c4.78-8.55,14.21-13.96,26.16-13.96C258.1,55.43,268.66,64.73,268.66,83.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.03,113.4l6.92-15.34c7.42,5.41,18.49,9.18,29.05,9.18c12.07,0,16.98-4.02,16.98-9.43 c0-16.48-51.19-5.16-51.19-37.85c0-14.97,12.07-27.42,37.1-27.42c11.07,0,22.39,2.64,30.56,7.8l-6.29,15.47 c-8.18-4.65-16.6-6.92-24.4-6.92c-12.07,0-16.73,4.53-16.73,10.06c0,16.22,51.19,5.03,51.19,37.35c0,14.71-12.2,27.29-37.35,27.29 C300.92,123.59,286.83,119.44,279.03,113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428.22,93.79h-51.19c1.89,8.43,9.06,13.58,19.37,13.58c7.17,0,12.33-2.14,16.98-6.54l10.44,11.32 c-6.29,7.17-15.72,10.94-27.92,10.94c-23.39,0-38.61-14.71-38.61-34.84c0-20.25,15.47-34.84,36.09-34.84 c19.87,0,35.21,13.33,35.21,35.09C428.59,90.01,428.34,92.15,428.22,93.79z M376.78,82.34h33.33c-1.38-8.55-7.8-14.09-16.6-14.09 C384.58,68.25,378.16,73.66,376.78,82.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M478.7,53.41v18.11c-1.63-0.13-2.89-0.25-4.4-0.25c-10.82,0-17.98,5.91-17.98,18.86v31.94H436.7V54.42h18.74 v8.93C460.21,56.81,468.26,53.41,478.7,53.41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemservLogoWhite);
export default __webpack_public_path__ + "static/media/remserv_logo_white.a0d389eff8b6811c8eec54d00a89399a.svg";
export { ForwardRef as ReactComponent };